import { useSelector } from 'react-redux';

import { INSURANCE_TYPES } from '../../../../../../../constants';

import type { RootState } from '../../../../../../../store';
import type { InsuranceType } from '../../../../../../../utils/types';

export default function useUpsertInsuranceLoading(insuranceType: InsuranceType) {
  return useSelector((state: RootState) =>
    insuranceType === INSURANCE_TYPES.PRIMARY
      ? state.onboardingQuestionnaire.upsertPrimaryInsuranceLoading
      : state.onboardingQuestionnaire.upsertSecondaryInsuranceLoading,
  );
}
